import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Vision() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Vision & Mission"
          title2=""
          parentTitle="About"
          path="Vision & Mission"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="row about-grid align-items-stretch">
            {/* Left Content */}
            <div className="col-12 col-xl-8">
              <div className="contact-form-card">
                <h2 className="about-title"> VISION OF CARMEL SCHOOL</h2>

                <div className="about-content-card">
                  <p>
                    We commit ourselves to create a healthy society and a better
                    world order by moulding each child into integrated,
                    sensitised and empowered individuals through academic
                    excellence, development of skills and character formation as
                    modelled in Jesus Christ.
                  </p>
                </div>
                <h2 className="about-title"> MISSION OF CARMEL SCHOOL</h2>

                <div className="about-content-card">
                  <p>
                    Our mission is to facilitate human excellence in students by
                    educating them intellectually, morally and spiritually to
                    discover and improve one's inherent gifts, and moral
                    sensitivity and sense of God.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-12 col-xl-4">
              <div className="contact-map-card about-image-card">
                <div className="about-image-wrap">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/mission.jpg"
                    alt="About School"
                    className="about-main-image img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Vision;
